import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from './store/chooseBgm';
import PageState from './store/state';
import MusicCards from './components/musicCards.vue';
import { MAudio } from "@/utils/audio";
import {judgeDeviceType} from "@/utils/device";
import { javaHost } from '@/bin/javaSetting';
import Axios from "axios"
/**components**/
@Component({
  components: {
    MusicCards,
  },
  watch: {
    visible: {
      handler(val) {
        this.show = val
      },
      immediate: true
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class ChooseBgm extends Vue {
  @Prop() visible!: boolean;
  state = new PageState();
  self: Vue = this;
  show = false;
  musicTypes = [
    { key: 'OFFICIAL', value: '官方库' },
    // { key: 'PERSONAL', value: '个人库' },
  ];
  currMusicTypeIcon =
    'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/curr_music_type_1703499891934.png';
  //第一个版本不使用分类/收藏-暂不使用
  moreUp =
    'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/more_up_1703520774831.png';
  morePull =
    'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/more_pull_1703520762845.png';
  morePullRed =
    'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/more_pull_red_1703520741219.png';
  heartWhite =
    'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/heart_white_1703520722043.png';
  heartRed =
    'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/heart_red_1703520690188.png';
  currTypeKey = 'OFFICIAL'; //当前选中的背景音乐类型
  musicList = []; //所有背景音
  isMusicListing = false; //背景音是否在试听
  allTagsList = []; //官方库的条件过滤对象
  currSelectIndex = null; //当前选择的查询类型
  selectTypeInfo = {
    //所有选择的查询条件value
    style: '',
    collect: '', //收藏
  };
  selectTypeInfoTxt = {
    //所有选择的查询条件name
    style: '',
    collect: '', //收藏
  };
  bgmAudio: any = null; //试听的背景音
  playState = 'initial'; //试听的背景音播放状态
  commitBgmId: any = null; //最后确认时的背景音
  persionTypeIdx = 0; //当前选中的个人背景音类型
  showLinkPopup = false; //是否显示链接
  // privateType = 'link'; //个人库选择的类型 link upload
  extractStatus = 'ready'; //提取/上传状态 'ready' 'loading' 'success' 'fail'
  linkContent = ''; //链接内容
  editable = false; //是否可编辑
  showResultPopup = false; //是否显示正在上传/提取中
  extractInfo = null; //链接提取后的内容
  uploadUrl = 'https://tts-files.mobvoi.com/v1/file/uploadToOss';
  hideBgmUrl = ''; //隐藏的audio的url
  // hideBgmDuraltion = ;//隐藏audio的duration -ms
  currBgm = null; //当前选中的背景音对象
  personalMusicResult = {
    link: {
      ready:{
        title: '提取中...',
        btnTxt: '提取完成后可使用',
      },
      loading: {
        title: '提取中...',
        btnTxt: '提取完成后可使用',
      },
      success: {
        title: '提取完成',
        btnTxt: '使用',
      },
      fail:{
        title: '提取失败',
        btnTxt: '重新提取',
      }
    },
  };
  currTempFile = null; //当前选中的临时文件
  ww_token = null;
  isApp = judgeDeviceType.isAPP;
  //todo
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    
    this.bgmAudio = MAudio.listen({
      playing: () => {
        this.playState = "playing";
      },
      pause: () => {
        this.playState = "paused";
      },
      ended: () => {
        this.playState = "initial";
      },
    });
  }
  mounted(moduleData: IinjectDatas) {
    (window as any).getAppClipBordContent = this.getAppClipBordContent;
    this.state.title = '背景音';
    this.state.self = this;
    this.ww_token = localStorage.getItem('ww_token');
    this.getBgmListFn();
  }
  @Watch('linkContent')
  focus() {
    setTimeout(() => {
      const $input = document.getElementById('linkInput')
      $input.scrollIntoView()
    }, 800)
  }
  initExtractInfo(){
    this.extractInfo = {}
  }
  getAppClipBordContent(message: string) {
    console.log('获取剪切板数据',message)
    this.linkContent = decodeURI(message) || ''
  }
  getBgmListFn(){
    let queryData = {typeEnum:this.currTypeKey};
    let vm = this;
    this.$http('getBgmList',queryData).then((res:any) =>{
      
      if(res.code === 200){
        vm.musicList = res.data;
        console.log('---getBgmList',vm.musicList);
      }
    })
  }
  chooseType (key) {
    this.currTypeKey = key;
    console.log('---chooseType',key);
    this.getBgmListFn();
    this.bgmStop();
  }
  clearHistory () {
    console.log('---清空历史');
    //调用接口 -todo
    //test - 下载视频-临时 待迁移
    // showExportPopup.value = true;
  }
  resetAllSelect(){
    this.selectTypeInfo= {
      //所有选择的查询条件value
      style: '',
      collect: '',
    };
    this.selectTypeInfoTxt = {
      //所有选择的查询条件name
      style: '',
      collect: '',
    };
    this.subSubType();
  }
  subSubType(){
    //调用查询
    // this.getSpeakerBySearchFn();
    this.currSelectIndex = null;
  }
  resetSubType(){}
  selectType(){}
  onPaste(){
    if (this.isApp) {
      let getClipBordContent: any = (<any>window).getClipBordContent
      getClipBordContent.postMessage('')
    }
  }
  clearVideoLink(){
    this.linkContent ='';
  }
  doExtract(){
    let self = this;
    let data ={
      ww_token: this.ww_token,
      url: this.linkContent,
      typeEnum:'LINK'
    }
    this.extractStatus='loading';//提取中
    this.showLinkPopup = false;//关闭链接弹窗
    this.showResultPopup = true;//显示提取/上传进度
    //调用接口
    Axios
			.post(`${javaHost}/baohuo-yuanchuang/backgroundMusic/extractSound?ww_token=${data.ww_token}`, data, {
				onUploadProgress: progressEvent => {},
				timeout: 1000 * 60 * 30 // 设置30分钟超时
			})
			.then((res: any) => {
        console.log('---结果',res)
        if(res.status!=200){
          self.extractStatus ='fail'
          self.extractInfo = null;
          self.$toast({
            message: '提取失败',
            position: 'bottom',
            duration: 3000
          });
          return;
        }
        if(res.data.code === 200){
          self.extractStatus ='success'
          self.hideBgmUrl = res.data.data.url;
          self.extractInfo = res.data.data;
          self.getBgmListFn();
        }else{
          self.extractStatus ='fail'
          self.extractInfo = null;
          self.$toast({
            message: res.data.message || '提取失败'
          })
          self.showResultPopup = false;
        }
      }).catch((err: any) =>{
        console.log('链接提取异常',err)
      })
  }
  triggerEdit(){
    this.editable = !this.editable;
  }
  deleteItem(id){
    console.log('---删除音频',id);
    let query={
      id:id,
      ww_token:this.ww_token
    }
    //调用删除接口
    this.$http('deleteBgmById',query).then((res: any)=>{
      //重新获取数据
      if(res.code === 200){
        this.$toast({
          message: '删除成功'
        })
        this.getBgmListFn();
      }else{
        this.$toast({
          message: '删除失败,请重试'
        })
      }
    })
    
  }
  bgmPlay(url){
    if(url !=  this.bgmAudio.src){
      this.bgmAudio.src && this.bgmAudio.stop();//停止上一次的播放
    }
    this.bgmAudio.setSrc(url);
    this.bgmAudio.play();
  }
  bgmPause(){
    this.bgmAudio.src && this.bgmAudio.pause();
  }
  bgmStop(){
    console.log('--url----背景音停止')
    this.bgmAudio && this.bgmAudio.stop();
  }
  useBgm(){
    if(this.extractStatus==='loading'){//提取中禁止点击
      return;
    }
    this.currBgm = this.extractInfo;
    //上传/提取完成之后使用背景音乐
    this.useMusic();
  }
  //使用个人库/官方库的背景音乐-todo 考虑当前页面变成组件
  useMusic(){
    this.bgmStop();
    let bgmInfo = {
      audioUrl: this.currBgm.url,
			audioName: this.currBgm.name,
			duration: this.currBgm.duration,
    }
    this.$emit("changeBgm", bgmInfo);
    this.closePopup()
  }
  setCurrBgm(item){
    this.currBgm = item;
  }
  audioByLinkFn(){
    this.showLinkPopup = true;
    // this.privateType ='link';//链接提取
  }
  /**
	 * 获取视频时长
	 * @param file
	 */
	getVideoDuration(file: File) {
		window.URL = window.URL || window.webkitURL
		let audio = document.createElement('audio');
		audio.preload = 'metadata';
		let self = this
		// video.src = URL.createObjectURL(file)
		audio.src = URL.createObjectURL(file);

		if (judgeDeviceType.isIOS && !judgeDeviceType.isWxBrowser) {
			audio.muted = true;
			audio.play().then(() => audio.pause())
		}
		audio.addEventListener('loadedmetadata', function () {
			window.URL.revokeObjectURL(audio.src)
			let duration = parseInt(audio.duration + '')
			// if (duration / 60 > 20) {
			// 	self.$toast('视频时长不能超过20分钟')
			// 	return;
			// }
      self.extractInfo.duration = duration;
      self.currTempFile.duration = parseInt(duration * 1000 as any);
		})
	}
  parseMillsTime(time: any) {
    var min:any = parseInt((time / 1000 / 60) as any);
    var sec:any = parseInt((time / 1000 ) % 60 as any);
    if (min < 10) {
      min = '0' + min;
    }
    if (sec < 10) {
      sec = '0' + sec;
    }
    return min + ':' + sec;
  }
  closePopup() {
    this.bgmStop();
    this.$emit('close')
  }
}
